export default "__VITE_ASSET__BeRklLBn__"